const isEscapeKey = (key) => key === "Escape";
const isEnterKey = (key) => key === "Enter";
const isTabKey = (key) => key === "Tab";
const isSpaceKey = (key) => key === " ";
const isArrowKeys = (key) => key.indexOf("Arrow") === 0;
const isHomeOrEndKeys = (key) => key === "Home" || key === "End";
const isPageKeys = (key) => key.indexOf("Page") === 0;
function isPrintableKey(event) {
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const isNavigationKey = (key) => isHomeOrEndKeys(key) || isArrowKeys(key) || isPageKeys(key) || isSpaceKey(key);
const isKeyboardEvent = (event) => !!event.key;
const isHideMenuKey = (key) => isTabKey(key) || isEscapeKey(key);
export {
  isArrowKeys,
  isEnterKey,
  isEscapeKey,
  isHideMenuKey,
  isHomeOrEndKeys,
  isKeyboardEvent,
  isNavigationKey,
  isPageKeys,
  isPrintableKey,
  isSpaceKey,
  isTabKey
};
//# sourceMappingURL=keyboardUtils.es.js.map
